import { useState } from "react";
import { inputCls, labelCls, FormActions } from "./common";

const vide = { titre: "", description: "", categorie: "Juridique", format: "En ligne", duree: "", prix: "", prochaine_session: "", lien: "", adresse: "", lien_zoom: "", ordre: 10, reductions: [] };

export const FormationForm = ({ initial, onSave, onCancel, saving }) => {
  const [f, setF] = useState(
    initial
      ? { ...initial, prix: initial.prix == null ? "" : initial.prix, lien: initial.lien || "", adresse: initial.adresse || "", lien_zoom: initial.lien_zoom || "", reductions: initial.reductions || [] }
      : vide
  );
  const set = (champ) => (e) => setF({ ...f, [champ]: e.target.value });

  const setReduction = (i, champ, valeur) => {
    const reductions = f.reductions.map((r, j) => (j === i ? { ...r, [champ]: valeur } : r));
    setF({ ...f, reductions });
  };

  const soumettre = (e) => {
    e.preventDefault();
    onSave({
      ...f,
      prix: f.prix === "" || f.prix == null ? null : Number(f.prix),
      reductions: (f.reductions || [])
        .filter((r) => r.pourcentage !== "" && r.pourcentage != null && r.date_limite)
        .map((r) => ({ pourcentage: Number(r.pourcentage), date_limite: r.date_limite })),
      lien: f.lien || null,
      adresse: f.adresse || null,
      lien_zoom: f.lien_zoom || null,
      ordre: Number(f.ordre),
    });
  };

  return (
    <form onSubmit={soumettre} className="space-y-5" data-testid="formation-form">
      <div>
        <label htmlFor="ff-titre" className={labelCls}>Titre *</label>
        <input id="ff-titre" required minLength={3} value={f.titre} onChange={set("titre")} className={inputCls} data-testid="formation-form-titre" />
      </div>
      <div>
        <label htmlFor="ff-description" className={labelCls}>Description *</label>
        <textarea id="ff-description" required minLength={10} rows={3} value={f.description} onChange={set("description")} className={`${inputCls} resize-y`} data-testid="formation-form-description" />
      </div>
      <div className="grid gap-5 md:grid-cols-2">
        <div>
          <label htmlFor="ff-categorie" className={labelCls}>Catégorie *</label>
          <select id="ff-categorie" value={f.categorie} onChange={set("categorie")} className={inputCls} data-testid="formation-form-categorie">
            <option>Juridique</option>
            <option>Fiscal</option>
            <option>Stratégique</option>
          </select>
        </div>
        <div>
          <label htmlFor="ff-format" className={labelCls}>Format *</label>
          <select id="ff-format" value={f.format} onChange={set("format")} className={inputCls} data-testid="formation-form-format">
            <option>En ligne</option>
            <option>En présentiel</option>
            <option>Hybride</option>
          </select>
        </div>
      </div>
      {(f.format === "En présentiel" || f.format === "Hybride") && (
        <div>
          <label htmlFor="ff-adresse" className={labelCls}>Adresse (présentiel)</label>
          <input id="ff-adresse" value={f.adresse} onChange={set("adresse")} className={inputCls} placeholder="666, rue Sherbrooke Ouest, bureau 2100, Montréal" data-testid="formation-form-adresse" />
        </div>
      )}
      {(f.format === "En ligne" || f.format === "Hybride") && (
        <div>
          <label htmlFor="ff-zoom" className={labelCls}>Lien Zoom (en ligne)</label>
          <input id="ff-zoom" type="url" value={f.lien_zoom} onChange={set("lien_zoom")} className={inputCls} placeholder="https://zoom.us/j/…" data-testid="formation-form-zoom" />
          <p className="mt-2 text-xs text-foreground/50">Jamais affiché publiquement — envoyé uniquement dans le courriel de confirmation aux personnes inscrites.</p>
        </div>
      )}
      <div className="grid gap-5 md:grid-cols-3">
        <div>
          <label htmlFor="ff-duree" className={labelCls}>Durée *</label>
          <input id="ff-duree" required value={f.duree} onChange={set("duree")} className={inputCls} placeholder="2 h" data-testid="formation-form-duree" />
        </div>
        <div>
          <label htmlFor="ff-prix" className={labelCls}>Prix ($, vide = voir Eventbrite)</label>
          <input id="ff-prix" type="number" min="0" step="1" value={f.prix} onChange={set("prix")} className={inputCls} placeholder="0 = gratuite" data-testid="formation-form-prix" />
        </div>
        <div>
          <label htmlFor="ff-ordre" className={labelCls}>Ordre d'affichage</label>
          <input id="ff-ordre" type="number" min="0" step="1" value={f.ordre} onChange={set("ordre")} className={inputCls} data-testid="formation-form-ordre" />
        </div>
      </div>
      <div>
        <label htmlFor="ff-session" className={labelCls}>Date de la session *</label>
        <input id="ff-session" required value={f.prochaine_session} onChange={set("prochaine_session")} className={inputCls} placeholder="22 octobre 2026, 18 h à 20 h" data-testid="formation-form-session" />
      </div>
      <div className="border border-border bg-card p-4" data-testid="formation-form-reductions">
        <p className={labelCls}>Réductions hâtives (automatiques selon la date d'inscription)</p>
        <p className="mb-3 mt-1 text-xs text-foreground/50">Le prix payé sur PayPal et affiché sur le site s'ajuste tout seul : la réduction en vigueur est celle dont la date limite n'est pas dépassée (la plus proche d'abord).</p>
        {f.reductions.map((r, i) => (
          <div key={i} className="mb-3 flex flex-wrap items-center gap-3" data-testid={`reduction-row-${i}`}>
            <span className="text-sm text-foreground/60">−</span>
            <input
              type="number" min="1" max="100" step="1"
              value={r.pourcentage}
              onChange={(e) => setReduction(i, "pourcentage", e.target.value)}
              className={`${inputCls} w-24`}
              placeholder="50"
              data-testid={`reduction-pourcentage-${i}`}
            />
            <span className="text-sm text-foreground/60">% jusqu'au</span>
            <input
              type="date"
              value={r.date_limite}
              onChange={(e) => setReduction(i, "date_limite", e.target.value)}
              className={inputCls}
              data-testid={`reduction-date-${i}`}
            />
            <button
              type="button"
              onClick={() => setF({ ...f, reductions: f.reductions.filter((_, j) => j !== i) })}
              className="text-xs font-semibold text-destructive hover:underline"
              data-testid={`reduction-supprimer-${i}`}
            >
              Retirer
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={() => setF({ ...f, reductions: [...f.reductions, { pourcentage: "", date_limite: "" }] })}
          className="rounded-sm border border-primary px-4 py-2 text-xs font-semibold text-primary transition-colors hover:bg-primary hover:text-primary-foreground"
          data-testid="reduction-ajouter"
        >
          + Ajouter une réduction
        </button>
      </div>
      <div>
        <label htmlFor="ff-lien" className={labelCls}>Lien Eventbrite (optionnel)</label>
        <input id="ff-lien" type="url" value={f.lien} onChange={set("lien")} className={inputCls} placeholder="https://www.eventbrite.ca/e/…" data-testid="formation-form-lien" />
        <p className="mt-2 text-xs text-foreground/50">Si rempli, le bouton « S'inscrire » mène à Eventbrite. Sinon, l'inscription se fait directement sur le site (avec paiement PayPal pour les formations payantes).</p>
      </div>
      <label className="flex items-center gap-3 border border-border bg-card px-4 py-3.5 text-sm font-semibold" data-testid="formation-form-passee-label">
        <input type="checkbox" checked={!!f.passee} onChange={(e) => setF({ ...f, passee: e.target.checked })} className="h-4 w-4 accent-[hsl(22,83%,46%)]" data-testid="formation-form-passee" />
        Formation déjà offerte (les inscriptions sont fermées — elle reste affichée comme formation passée)
      </label>
      <FormActions saving={saving} onCancel={onCancel} />
    </form>
  );
};
